import { Modal, LargeRadio, WhatsAppButton, Subtitle, Title } from '~components'
import { useRequest } from 'ahooks'
import { Auth } from '~services'
import { usePathValidation, useStore, useNavigate, useTitle } from '~hooks'
import { DataPasswordRecovery, Params, Values } from './interfaces'
import { useForm } from 'react-hook-form'
import { ReactElement, useEffect, useState } from 'react'
import * as Styled from './styled'
import { track } from '@amplitude/analytics-browser'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

function Cellphone() {
  const modalButton = {
    onClick: handleClickPrimaryButton,
    text: 'WhatsApp',
    forWhatsApp: true,
  }
  const navigate = useNavigate()
  const { cpf, update, passwordRecovery: passwordRecoveryData } = useStore()
  const [openModal, setOpenModal] = useState(false)
  const [data, setData] = useState<DataPasswordRecovery>()
  const [error, setError] = useState<Error>(null)

  const { executeRecaptcha } = useGoogleReCaptcha()

  const defaultValues = { phone: passwordRecoveryData?.cellphone?.number || '' }
  const { handleSubmit, register, watch, setValue } = useForm<Values>({
    defaultValues,
    mode: 'onChange',
  })
  const phoneId = watch('phone')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await executeRecaptcha()
        const data = await passwordRecovery(cpf, token)
        setData(data)

      } catch (error) {
        setError(error as Error)
      }
    }

    fetchData()
  }, [])

  const { loading, runAsync: passwordRecovery } = useRequest<DataPasswordRecovery, Params>(
    Auth.passwordRecovery,
    {
      manual: true
    },
  )

  const phone = data?.find?.((item) => item.id === phoneId)

  useTitle('Recuperar senha - Fretebras')
  usePathValidation(['cpf'])

  function handleClickPrimaryButton() {
    track('ignito__recuperacao_de_senha__seleciona_telefone__contato_whatsapp')
    window.open(
      `https://wa.me/551141181843/?text=Olá, meu CPF é ${cpf} e troquei de telefone. Por isso, não consigo recuperar minha senha. Pode me ajudar?`,
    )
  }
  function handleClickWhatsapp() {
    track('ignito__recuperacao_de_senha__seleciona_telefone__recupera_por_whatsapp', {
      phoneNumber: phone?.number,
    })
    setValue('method', 'whatsapp')
  }
  function handleClickSMS() {
    track('ignito__recuperacao_de_senha__seleciona_telefone__recupera_por_sms', {
      phoneNumber: phone?.number,
    })
    setValue('method', 'sms')
  }
  function handleClickIsNotMyPhone() {
    track('ignito__recuperacao_de_senha__seleciona_telefone__numeros_errados')
    setOpenModal(true)
  }
  function handleClose() {
    setOpenModal(false)
  }
  function onSubmit(values: Values) {
    if (values.method === 'whatsapp') {
      update({ passwordRecovery: { cellphone: phone } })
      navigate('/recuperar-senha-motorista/validar', {
        state: { previousPath: '/recuperar-senha-motorista', option: 'whatsapp' },
      })
    }
    if (values.method === 'sms') {
      update({ passwordRecovery: { cellphone: phone } })
      navigate('/recuperar-senha-motorista/validar', {
        state: { previousPath: '/recuperar-senha-motorista', option: 'sms' },
      })
    }
  }

  if (error) {
    navigate('/erro', {
      state: { previousPath: '/recuperar-senha-motorista' },
    })
  }

  const Content = (): ReactElement | ReactElement[] => {
    if (loading)
      return (
        <Styled.SkeletonContainer>
          <Styled.Skeleton />
        </Styled.SkeletonContainer>
      )

    return data?.map((item) => (
      <LargeRadio
        register={register}
        key={item.id}
        id={item.id}
        type="radio"
        name="phone"
        label={item.number}
      />
    ))
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} aria-labelledby="form-cellphone-title">
      <Title id="form-cellphone-title">Não se preocupe!</Title>
      <Subtitle>
        Escolha um telefone cadastrado e a melhor forma de recuperação de senha.
      </Subtitle>
      {Content()}
      <WhatsAppButton
        width="100%"
        disabled={!phone?.valid_whatsapp}
        onClick={handleClickWhatsapp}
      >
        Recuperar pelo WhatsApp
      </WhatsAppButton>
      <Styled.Button
        type="submit"
        color="tertiary"
        onClick={handleClickSMS}
        disabled={!phone?.number}
      >
        Recuperar por SMS
      </Styled.Button>
      <Styled.Button type="button" color="subtle" onClick={handleClickIsNotMyPhone}>
        Meu número de telefone não é esse!
      </Styled.Button>
      <Modal
        open={openModal}
        onClose={handleClose}
        title="Seu telefone mudou?"
        message="Se o seu número de celular mudou e você não lembra a sua senha, entre em contato que nós vamos te ajudar."
        disclaimer="Horário de atendimento: Segunda a sexta das 8h às 20h, exceto feriados."
        buttons={{ primary: modalButton }}
      />
    </form>
  )
}

export default Cellphone
